import type { ReactElement } from "react"
import React from "react"
import { chunk } from "lodash"
import ListMol from "@onestore/hel/dist/components/molecules/ListMol"
import GridOrg from "@onestore/hel/dist/components/organisms/GridOrg"
import SurfaceOrg from "@onestore/hel/dist/components/organisms/SurfaceOrg"
import useBreakpoint from "@onestore/hel/dist/hooks/useBreakpoint"

interface ProductFeaturesProps {
  productFeatures: string[]
}

export default function ProductFeatures({
  productFeatures,
}: ProductFeaturesProps): ReactElement<ProductFeaturesProps> | null {
  const isSmallScreen = useBreakpoint("small", "medium")

  if (productFeatures.length === 0) {
    return null
  }

  if (isSmallScreen) {
    return null
  }

  return (
    <SurfaceOrg spacingSpace={4}>
      <GridOrg columns={2} gutterSpace={1.5}>
        {chunk(productFeatures, Math.ceil(productFeatures.length / 2)).map(
          (productFeaturesItems, key) => (
            <ListMol
              type="tick"
              size="medium"
              iconColor="success"
              items={productFeaturesItems}
              key={key}
            />
          )
        )}
      </GridOrg>
    </SurfaceOrg>
  )
}
